import styled from 'styled-components'

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(
    ${(props) =>
      `${props.templateColumn}, ${props.templateColumnSize}`}
  );
  grid-template-rows: auto;
  grid-column-gap: ${(props) => props.columnGap};
  grid-row-gap: ${(props) => props.rowGap};
  padding: ${(props) => props.padding};
`

interface IGrid {
  children: JSX.Element
  templateColumn?: number
  templateColumnSize?: string
  columnGap?: string
  rowGap?: string
  padding?: string
}

function Grid({
  children,
  templateColumn = 1,
  templateColumnSize = '2fr',
  columnGap = '0',
  rowGap = '0',
  padding = '0',
  ...props
}: IGrid): JSX.Element {
  return (
    <StyledGrid
      templateColumn={templateColumn}
      templateColumnSize={templateColumnSize}
      columnGap={columnGap}
      rowGap={rowGap}
      padding={padding}
      {...props}
    >
      {children}
    </StyledGrid>
  )
}

export default Grid
